<form [formGroup]="form" style="margin-bottom: 16px;">
  <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
    <div class="field">
      <label class="field__label">Fee Label*</label>
      <input class="field__input" type="text" formControlName="feeLabel" name="feeLabel" placeholder="Enter label"
        autocomplete="off" required [class.field__input--invalid]="feeLabel.invalid && feeLabel.touched" />
      @if (feeLabel.invalid && (feeLabel.dirty || feeLabel.touched)) {
      <span class="field__error">{{formHelper.validationMessages['feeLabel'].required}}</span>
      }
    </div>
    <div class="field">
      <label class="field__label">Fee Detail Description*</label>
      <input class="field__input" type="text" formControlName="feeDescription" name="feeDescription"
        placeholder="Enter description" autocomplete="off" required
        [class.field__input--invalid]="feeDescription.invalid && feeDescription.touched" />
      @if (feeDescription.invalid && (feeDescription.dirty || feeDescription.touched)) {
      <span class="field__error">{{formHelper.validationMessages['feeDescription'].required}}</span>
      }
    </div>
  </div>
  <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; gap: 8px; margin-top: 8px;">
    <div class="field">
      <label class="field__label">Volume ($)*</label>
      <input class="field__input" type="number" formControlName="volume" name="volume" placeholder="Enter dollar amount"
        required [class.field__input--invalid]="volume.invalid && volume.touched" />
      @if (volume.invalid && (volume.dirty || volume.touched)) {
      <span class="field__error">{{formHelper.validationMessages['volume'].required}}</span>
      }
    </div>
    <div class="field">
      <label class="field__label"># of Transactions*</label>
      <input class="field__input" type="number" formControlName="numberOfTransactions" name="numberOfTransactions"
        placeholder="Enter number" required
        [class.field__input--invalid]="numberOfTransactions.invalid && numberOfTransactions.touched" />
      @if (numberOfTransactions.invalid && (numberOfTransactions.dirty || numberOfTransactions.touched)) {
      <span class="field__error">{{formHelper.validationMessages['numberOfTransactions'].required}}</span>
      }
    </div>
    <div class="field">
      <label class="field__label">Transaction Rate (%)</label>
      <input class="field__input" type="number" formControlName="transactionRate" name="transactionRate"
        placeholder="Enter rate" />
    </div>
    <div class="field">
      <label class="field__label">Per Item Fee ($)</label>
      <input class="field__input" type="number" formControlName="fees" name="fees" placeholder="Enter fee" />
    </div>
  </div>
  @if (showRemove) {
  <div style="text-align: center; margin-top: 8px;">
    <a class="remove-link" (click)="remove.emit()">remove fee detail</a>
  </div>
  }
</form>